
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $941c79669971cb8a$exports = {};
/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */ (function(root, factory) {
    if (typeof define === 'function' && define.amd) define(factory);
    else $941c79669971cb8a$exports = factory();
})($941c79669971cb8a$exports, function() {
    var NProgress = {};
    NProgress.version = '0.2.0';
    var Settings = NProgress.settings = {
        minimum: 0.08,
        easing: 'ease',
        positionUsing: '',
        speed: 200,
        trickle: true,
        trickleRate: 0.02,
        trickleSpeed: 800,
        showSpinner: true,
        barSelector: '[role="bar"]',
        spinnerSelector: '[role="spinner"]',
        parent: 'body',
        template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
    };
    /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */ NProgress.configure = function(options) {
        var key, value;
        for(key in options){
            value = options[key];
            if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
        }
        return this;
    };
    /**
   * Last number.
   */ NProgress.status = null;
    /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */ NProgress.set = function(n) {
        var started = NProgress.isStarted();
        n = clamp(n, Settings.minimum, 1);
        NProgress.status = n === 1 ? null : n;
        var progress = NProgress.render(!started), bar = progress.querySelector(Settings.barSelector), speed = Settings.speed, ease = Settings.easing;
        progress.offsetWidth; /* Repaint */ 
        queue(function(next) {
            // Set positionUsing if it hasn't already been set
            if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();
            // Add transition
            css(bar, barPositionCSS(n, speed, ease));
            if (n === 1) {
                // Fade out
                css(progress, {
                    transition: 'none',
                    opacity: 1
                });
                progress.offsetWidth; /* Repaint */ 
                setTimeout(function() {
                    css(progress, {
                        transition: 'all ' + speed + 'ms linear',
                        opacity: 0
                    });
                    setTimeout(function() {
                        NProgress.remove();
                        next();
                    }, speed);
                }, speed);
            } else setTimeout(next, speed);
        });
        return this;
    };
    NProgress.isStarted = function() {
        return typeof NProgress.status === 'number';
    };
    /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */ NProgress.start = function() {
        if (!NProgress.status) NProgress.set(0);
        var work = function() {
            setTimeout(function() {
                if (!NProgress.status) return;
                NProgress.trickle();
                work();
            }, Settings.trickleSpeed);
        };
        if (Settings.trickle) work();
        return this;
    };
    /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */ NProgress.done = function(force) {
        if (!force && !NProgress.status) return this;
        return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
    };
    /**
   * Increments by a random amount.
   */ NProgress.inc = function(amount) {
        var n = NProgress.status;
        if (!n) return NProgress.start();
        else {
            if (typeof amount !== 'number') amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
            n = clamp(n + amount, 0, 0.994);
            return NProgress.set(n);
        }
    };
    NProgress.trickle = function() {
        return NProgress.inc(Math.random() * Settings.trickleRate);
    };
    /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   *
   * @param $promise jQUery Promise
   */ (function() {
        var initial = 0, current = 0;
        NProgress.promise = function($promise) {
            if (!$promise || $promise.state() === "resolved") return this;
            if (current === 0) NProgress.start();
            initial++;
            current++;
            $promise.always(function() {
                current--;
                if (current === 0) {
                    initial = 0;
                    NProgress.done();
                } else NProgress.set((initial - current) / initial);
            });
            return this;
        };
    })();
    /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */ NProgress.render = function(fromStart) {
        if (NProgress.isRendered()) return document.getElementById('nprogress');
        addClass(document.documentElement, 'nprogress-busy');
        var progress = document.createElement('div');
        progress.id = 'nprogress';
        progress.innerHTML = Settings.template;
        var bar = progress.querySelector(Settings.barSelector), perc = fromStart ? '-100' : toBarPerc(NProgress.status || 0), parent = document.querySelector(Settings.parent), spinner;
        css(bar, {
            transition: 'all 0 linear',
            transform: 'translate3d(' + perc + '%,0,0)'
        });
        if (!Settings.showSpinner) {
            spinner = progress.querySelector(Settings.spinnerSelector);
            spinner && removeElement(spinner);
        }
        if (parent != document.body) addClass(parent, 'nprogress-custom-parent');
        parent.appendChild(progress);
        return progress;
    };
    /**
   * Removes the element. Opposite of render().
   */ NProgress.remove = function() {
        removeClass(document.documentElement, 'nprogress-busy');
        removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
        var progress = document.getElementById('nprogress');
        progress && removeElement(progress);
    };
    /**
   * Checks if the progress bar is rendered.
   */ NProgress.isRendered = function() {
        return !!document.getElementById('nprogress');
    };
    /**
   * Determine which positioning CSS rule to use.
   */ NProgress.getPositioningCSS = function() {
        // Sniff on document.body.style
        var bodyStyle = document.body.style;
        // Sniff prefixes
        var vendorPrefix = 'WebkitTransform' in bodyStyle ? 'Webkit' : 'MozTransform' in bodyStyle ? 'Moz' : 'msTransform' in bodyStyle ? 'ms' : 'OTransform' in bodyStyle ? 'O' : '';
        if (vendorPrefix + 'Perspective' in bodyStyle) // Modern browsers with 3D support, e.g. Webkit, IE10
        return 'translate3d';
        else if (vendorPrefix + 'Transform' in bodyStyle) // Browsers without 3D support, e.g. IE9
        return 'translate';
        else // Browsers without translate() support, e.g. IE7-8
        return 'margin';
    };
    /**
   * Helpers
   */ function clamp(n, min, max) {
        if (n < min) return min;
        if (n > max) return max;
        return n;
    }
    /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */ function toBarPerc(n) {
        return (-1 + n) * 100;
    }
    /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */ function barPositionCSS(n, speed, ease) {
        var barCSS;
        if (Settings.positionUsing === 'translate3d') barCSS = {
            transform: 'translate3d(' + toBarPerc(n) + '%,0,0)'
        };
        else if (Settings.positionUsing === 'translate') barCSS = {
            transform: 'translate(' + toBarPerc(n) + '%,0)'
        };
        else barCSS = {
            'margin-left': toBarPerc(n) + '%'
        };
        barCSS.transition = 'all ' + speed + 'ms ' + ease;
        return barCSS;
    }
    /**
   * (Internal) Queues a function to be executed.
   */ var queue = function() {
        var pending = [];
        function next() {
            var fn = pending.shift();
            if (fn) fn(next);
        }
        return function(fn) {
            pending.push(fn);
            if (pending.length == 1) next();
        };
    }();
    /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */ var css = function() {
        var cssPrefixes = [
            'Webkit',
            'O',
            'Moz',
            'ms'
        ], cssProps = {};
        function camelCase(string) {
            return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function(match, letter) {
                return letter.toUpperCase();
            });
        }
        function getVendorProp(name) {
            var style = document.body.style;
            if (name in style) return name;
            var i = cssPrefixes.length, capName = name.charAt(0).toUpperCase() + name.slice(1), vendorName;
            while(i--){
                vendorName = cssPrefixes[i] + capName;
                if (vendorName in style) return vendorName;
            }
            return name;
        }
        function getStyleProp(name) {
            name = camelCase(name);
            return cssProps[name] || (cssProps[name] = getVendorProp(name));
        }
        function applyCss(element, prop, value) {
            prop = getStyleProp(prop);
            element.style[prop] = value;
        }
        return function(element, properties) {
            var args = arguments, prop, value;
            if (args.length == 2) for(prop in properties){
                value = properties[prop];
                if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
            }
            else applyCss(element, args[1], args[2]);
        };
    }();
    /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */ function hasClass(element, name) {
        var list = typeof element == 'string' ? element : classList(element);
        return list.indexOf(' ' + name + ' ') >= 0;
    }
    /**
   * (Internal) Adds a class to an element.
   */ function addClass(element, name) {
        var oldList = classList(element), newList = oldList + name;
        if (hasClass(oldList, name)) return;
        // Trim the opening space.
        element.className = newList.substring(1);
    }
    /**
   * (Internal) Removes a class from an element.
   */ function removeClass(element, name) {
        var oldList = classList(element), newList;
        if (!hasClass(element, name)) return;
        // Replace the class name.
        newList = oldList.replace(' ' + name + ' ', ' ');
        // Trim the opening and closing spaces.
        element.className = newList.substring(1, newList.length - 1);
    }
    /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */ function classList(element) {
        return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
    }
    /**
   * (Internal) Removes an element from the DOM.
   */ function removeElement(element) {
        element && element.parentNode && element.parentNode.removeChild(element);
    }
    return NProgress;
});



(0, (/*@__PURE__*/$parcel$interopDefault($941c79669971cb8a$exports))).configure({
    showSpinner: false
});
const $650607d6ef817a02$var$HISTORY_KEY = "gdf-history";
const $650607d6ef817a02$var$MAX_HISTORY = 8;
const $650607d6ef817a02$var$EXAMPLE_USERS = [
    "abhishekjaiswar221",
    "torvalds",
    "gaearon",
    "sindresorhus"
];
const $650607d6ef817a02$var$LANGUAGE_COLORS = {
    JavaScript: "#f1e05a",
    TypeScript: "#3178c6",
    Python: "#3572A5",
    Java: "#b07219",
    HTML: "#e34c26",
    CSS: "#563d7c",
    Go: "#00ADD8",
    Rust: "#dea584",
    Ruby: "#701516",
    PHP: "#4F5D95",
    "C++": "#f34b7d",
    C: "#555555",
    "C#": "#178600",
    Shell: "#89e051",
    Swift: "#F05138",
    Kotlin: "#A97BFF",
    Dart: "#00B4AB"
};
class $650607d6ef817a02$var$GitHubApiError extends Error {
    constructor(type, resetAt = null){
        super(type);
        this.type = type;
        this.resetAt = resetAt;
    }
}
const $650607d6ef817a02$var$CACHE_TTL_MS = 300000;
const $650607d6ef817a02$var$cache = new Map();
function $650607d6ef817a02$var$getCached(key) {
    const entry = $650607d6ef817a02$var$cache.get(key);
    if (!entry) return null;
    if (Date.now() - entry.time > $650607d6ef817a02$var$CACHE_TTL_MS) {
        $650607d6ef817a02$var$cache.delete(key);
        return null;
    }
    return entry.data;
}
function $650607d6ef817a02$var$setCached(key, data) {
    $650607d6ef817a02$var$cache.set(key, {
        data: data,
        time: Date.now()
    });
}
function $650607d6ef817a02$var$escapeHtml(value) {
    if (value === null || value === undefined) return "";
    return String(value).replace(/[&<>"']/g, (c)=>({
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
        })[c]);
}
function $650607d6ef817a02$var$toSafeHttpUrl(url) {
    if (!url) return null;
    const withProtocol = /^https?:\/\//i.test(url) ? url : `https://${url}`;
    try {
        const parsed = new URL(withProtocol);
        if (parsed.protocol === "http:" || parsed.protocol === "https:") return parsed.href;
    } catch (_) {
    // fall through
    }
    return null;
}
function $650607d6ef817a02$var$formatCompact(value) {
    return new Intl.NumberFormat("en", {
        notation: "compact",
        maximumFractionDigits: 1
    }).format(value ?? 0);
}
function $650607d6ef817a02$var$formatJoinDate(iso) {
    return new Intl.DateTimeFormat("en-US", {
        month: "long",
        year: "numeric"
    }).format(new Date(iso));
}
function $650607d6ef817a02$var$formatRelativeTime(iso) {
    const seconds = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
    const rtf = new Intl.RelativeTimeFormat("en", {
        numeric: "auto"
    });
    const units = [
        [
            "year",
            31536000
        ],
        [
            "month",
            2592000
        ],
        [
            "day",
            86400
        ],
        [
            "hour",
            3600
        ],
        [
            "minute",
            60
        ]
    ];
    for (const [unit, secondsInUnit] of units){
        if (seconds >= secondsInUnit) return rtf.format(-Math.floor(seconds / secondsInUnit), unit);
    }
    return rtf.format(0, "second");
}
function $650607d6ef817a02$var$rateLimitResetAt(res) {
    const reset = res.headers.get("x-ratelimit-reset");
    return reset ? new Date(Number(reset) * 1000) : null;
}
async function $650607d6ef817a02$var$fetchUser(username) {
    const cacheKey = `user:${username.toLowerCase()}`;
    const cached = $650607d6ef817a02$var$getCached(cacheKey);
    if (cached) return cached;
    const res = await fetch(`https://api.github.com/users/${encodeURIComponent(username)}`);
    if (res.status === 404) throw new $650607d6ef817a02$var$GitHubApiError("not-found");
    if (res.status === 403) throw new $650607d6ef817a02$var$GitHubApiError("rate-limit", $650607d6ef817a02$var$rateLimitResetAt(res));
    if (!res.ok) throw new $650607d6ef817a02$var$GitHubApiError("request-failed");
    const data = await res.json();
    $650607d6ef817a02$var$setCached(cacheKey, data);
    return data;
}
async function $650607d6ef817a02$var$fetchTopRepos(username) {
    const cacheKey = `repos:${username.toLowerCase()}`;
    const cached = $650607d6ef817a02$var$getCached(cacheKey);
    if (cached) return cached;
    const res = await fetch(`https://api.github.com/users/${encodeURIComponent(username)}/repos?per_page=100&sort=updated`);
    if (!res.ok) return [];
    const repos = await res.json();
    if (!Array.isArray(repos)) return [];
    const topRepos = repos.filter((repo)=>!repo.fork).sort((a, b)=>b.stargazers_count - a.stargazers_count).slice(0, 6);
    $650607d6ef817a02$var$setCached(cacheKey, topRepos);
    return topRepos;
}
function $650607d6ef817a02$var$getHistory() {
    try {
        const stored = JSON.parse(localStorage.getItem($650607d6ef817a02$var$HISTORY_KEY));
        return Array.isArray(stored) ? stored : [];
    } catch (_) {
        return [];
    }
}
function $650607d6ef817a02$var$addToHistory(login) {
    const history = $650607d6ef817a02$var$getHistory().filter((entry)=>entry.toLowerCase() !== login.toLowerCase());
    history.unshift(login);
    localStorage.setItem($650607d6ef817a02$var$HISTORY_KEY, JSON.stringify(history.slice(0, $650607d6ef817a02$var$MAX_HISTORY)));
}
function $650607d6ef817a02$var$metaItem(icon, text) {
    return `<span class="profile-meta-item"><i class="bi bi-${icon}"></i>${text}</span>`;
}
function $650607d6ef817a02$var$statTile(icon, value, label) {
    return `
    <div class="stat-tile">
      <i class="bi bi-${icon}"></i>
      <div class="stat-value">${$650607d6ef817a02$var$formatCompact(value)}</div>
      <div class="stat-label">${label}</div>
    </div>
  `;
}
function $650607d6ef817a02$var$profileCardHtml(user) {
    const blogUrl = $650607d6ef817a02$var$toSafeHttpUrl(user.blog);
    const twitterUrl = user.twitter_username ? `https://x.com/${encodeURIComponent(user.twitter_username)}` : null;
    const metaParts = [
        user.location ? $650607d6ef817a02$var$metaItem("geo-alt-fill", $650607d6ef817a02$var$escapeHtml(user.location)) : "",
        user.company ? $650607d6ef817a02$var$metaItem("building", $650607d6ef817a02$var$escapeHtml(user.company)) : "",
        blogUrl ? `<a class="profile-meta-item" href="${blogUrl}" target="_blank" rel="noopener"><i class="bi bi-link-45deg"></i>${$650607d6ef817a02$var$escapeHtml(user.blog)}</a>` : "",
        $650607d6ef817a02$var$metaItem("calendar3", `Joined ${$650607d6ef817a02$var$formatJoinDate(user.created_at)}`)
    ].join("");
    return `
    <div class="profile-main">
      <img class="profile-avatar" src="${$650607d6ef817a02$var$escapeHtml(user.avatar_url)}" alt="${$650607d6ef817a02$var$escapeHtml(user.login)}'s avatar" loading="lazy">
      <div class="profile-info">
        <div class="profile-name-row">
          <h2 class="profile-name">${$650607d6ef817a02$var$escapeHtml(user.name || user.login)}</h2>
          ${user.hireable ? '<span class="badge badge-hireable"><i class="bi bi-briefcase-fill"></i> Open to work</span>' : ""}
        </div>
        <a class="profile-login" href="${$650607d6ef817a02$var$escapeHtml(user.html_url)}" target="_blank" rel="noopener">@${$650607d6ef817a02$var$escapeHtml(user.login)}</a>
        ${user.bio ? `<p class="profile-bio">${$650607d6ef817a02$var$escapeHtml(user.bio)}</p>` : ""}
        <div class="profile-meta">${metaParts}</div>
      </div>
    </div>

    <div class="profile-stats">
      ${$650607d6ef817a02$var$statTile("people-fill", user.followers, "Followers")}
      ${$650607d6ef817a02$var$statTile("person-plus-fill", user.following, "Following")}
      ${$650607d6ef817a02$var$statTile("journal-code", user.public_repos, "Repos")}
      ${$650607d6ef817a02$var$statTile("collection-fill", user.public_gists, "Gists")}
    </div>

    <div class="profile-actions">
      <a class="btn-primary" href="${$650607d6ef817a02$var$escapeHtml(user.html_url)}" target="_blank" rel="noopener">
        <i class="bi bi-box-arrow-up-right"></i> View on GitHub
      </a>
      <button type="button" class="btn-secondary" id="copy-link-btn" data-url="${$650607d6ef817a02$var$escapeHtml(user.html_url)}">
        <i class="bi bi-clipboard"></i> Copy link
      </button>
      ${user.email ? `<a class="btn-icon" href="mailto:${$650607d6ef817a02$var$escapeHtml(user.email)}" title="Email"><i class="bi bi-envelope-fill"></i></a>` : ""}
      ${twitterUrl ? `<a class="btn-icon" href="${twitterUrl}" target="_blank" rel="noopener" title="Twitter / X"><i class="bi bi-twitter"></i></a>` : ""}
      <a class="btn-icon" href="${$650607d6ef817a02$var$escapeHtml(user.url)}" target="_blank" rel="noopener" title="Raw JSON"><i class="bi bi-braces"></i></a>
    </div>
  `;
}
function $650607d6ef817a02$var$repoCardHtml(repo) {
    const color = $650607d6ef817a02$var$LANGUAGE_COLORS[repo.language] || "#8b949e";
    return `
    <a class="repo-card" href="${$650607d6ef817a02$var$escapeHtml(repo.html_url)}" target="_blank" rel="noopener">
      <div class="repo-card-header">
        <i class="bi bi-journal-code"></i>
        <span class="repo-name">${$650607d6ef817a02$var$escapeHtml(repo.name)}</span>
      </div>
      <p class="repo-desc">${repo.description ? $650607d6ef817a02$var$escapeHtml(repo.description) : "No description provided."}</p>
      <div class="repo-meta">
        ${repo.language ? `<span class="repo-lang"><span class="lang-dot" style="background:${color}"></span>${$650607d6ef817a02$var$escapeHtml(repo.language)}</span>` : ""}
        <span class="repo-stat"><i class="bi bi-star-fill"></i>${$650607d6ef817a02$var$formatCompact(repo.stargazers_count)}</span>
        <span class="repo-stat"><i class="bi bi-diagram-2-fill"></i>${$650607d6ef817a02$var$formatCompact(repo.forks_count)}</span>
      </div>
      <div class="repo-updated"><i class="bi bi-clock-history"></i>Updated ${$650607d6ef817a02$var$formatRelativeTime(repo.updated_at)}</div>
    </a>
  `;
}
document.addEventListener("DOMContentLoaded", ()=>{
    const form = document.getElementById("search-form");
    const usernameInput = document.getElementById("username");
    const quickChips = document.getElementById("quick-chips");
    const historyRow = document.getElementById("history-row");
    const historyChips = document.getElementById("history-chips");
    const clearHistoryBtn = document.getElementById("clear-history");
    const states = {
        empty: document.getElementById("state-empty"),
        loading: document.getElementById("state-loading"),
        error: document.getElementById("state-error"),
        result: document.getElementById("state-result")
    };
    const errorIcon = document.getElementById("error-icon");
    const errorTitle = document.getElementById("error-title");
    const errorText = document.getElementById("error-text");
    const retryBtn = document.getElementById("retry-btn");
    const profileCard = document.getElementById("profile-card");
    const reposGrid = document.getElementById("repos-grid");
    const reposCount = document.getElementById("repos-count");
    let lastQuery = "";
    function setState(name) {
        for (const key of Object.keys(states))states[key].hidden = key !== name;
    }
    function renderQuickChips() {
        quickChips.innerHTML = $650607d6ef817a02$var$EXAMPLE_USERS.map((name)=>`<button type="button" class="chip" data-username="${$650607d6ef817a02$var$escapeHtml(name)}">${$650607d6ef817a02$var$escapeHtml(name)}</button>`).join("");
    }
    function renderHistory() {
        const history = $650607d6ef817a02$var$getHistory();
        historyRow.hidden = history.length === 0;
        historyChips.innerHTML = history.map((name)=>`<button type="button" class="chip" data-username="${$650607d6ef817a02$var$escapeHtml(name)}">${$650607d6ef817a02$var$escapeHtml(name)}</button>`).join("");
    }
    function renderRepos(repos) {
        reposCount.textContent = repos.length ? `${repos.length} shown` : "";
        reposGrid.innerHTML = repos.length ? repos.map($650607d6ef817a02$var$repoCardHtml).join("") : `<p class="repos-empty">No public repositories to show.</p>`;
    }
    function renderProfile(user) {
        profileCard.innerHTML = $650607d6ef817a02$var$profileCardHtml(user);
        const copyBtn = document.getElementById("copy-link-btn");
        copyBtn.addEventListener("click", async ()=>{
            try {
                await navigator.clipboard.writeText(copyBtn.dataset.url);
                const label = copyBtn.innerHTML;
                copyBtn.innerHTML = '<i class="bi bi-clipboard-check"></i> Copied!';
                setTimeout(()=>{
                    copyBtn.innerHTML = label;
                }, 1500);
            } catch (_) {
            // clipboard not available; ignore
            }
        });
    }
    function showError(type, resetAt) {
        const rateLimitText = resetAt ? `GitHub's API rate limit was exceeded. It resets at ${new Intl.DateTimeFormat("en", {
            hour: "numeric",
            minute: "2-digit"
        }).format(resetAt)}.` : "GitHub's API rate limit was exceeded. Please try again in a few minutes.";
        const config = {
            "not-found": {
                icon: "bi-emoji-frown",
                title: "User not found",
                text: `We couldn't find a GitHub user named "${lastQuery}".`
            },
            "rate-limit": {
                icon: "bi-hourglass-split",
                title: "Rate limit reached",
                text: rateLimitText
            },
            "request-failed": {
                icon: "bi-wifi-off",
                title: "Something went wrong",
                text: "Check your connection and try again."
            }
        };
        const c = config[type] || config["request-failed"];
        errorIcon.className = `bi ${c.icon} state-icon`;
        errorTitle.textContent = c.title;
        errorText.textContent = c.text;
    }
    async function runSearch(username) {
        lastQuery = username;
        usernameInput.value = username;
        setState("loading");
        (0, (/*@__PURE__*/$parcel$interopDefault($941c79669971cb8a$exports))).start();
        try {
            const [user, repos] = await Promise.all([
                $650607d6ef817a02$var$fetchUser(username),
                $650607d6ef817a02$var$fetchTopRepos(username)
            ]);
            renderProfile(user);
            renderRepos(repos);
            setState("result");
            $650607d6ef817a02$var$addToHistory(user.login);
            renderHistory();
        } catch (err) {
            if (err instanceof $650607d6ef817a02$var$GitHubApiError) showError(err.type, err.resetAt);
            else showError("request-failed");
            setState("error");
        } finally{
            (0, (/*@__PURE__*/$parcel$interopDefault($941c79669971cb8a$exports))).done();
        }
    }
    form.addEventListener("submit", (e)=>{
        e.preventDefault();
        const value = usernameInput.value.trim();
        if (value) runSearch(value);
    });
    quickChips.addEventListener("click", (e)=>{
        const chip = e.target.closest(".chip");
        if (chip) runSearch(chip.dataset.username);
    });
    historyChips.addEventListener("click", (e)=>{
        const chip = e.target.closest(".chip");
        if (chip) runSearch(chip.dataset.username);
    });
    clearHistoryBtn.addEventListener("click", ()=>{
        localStorage.removeItem($650607d6ef817a02$var$HISTORY_KEY);
        renderHistory();
    });
    retryBtn.addEventListener("click", ()=>{
        if (lastQuery) runSearch(lastQuery);
    });
    renderQuickChips();
    renderHistory();
});


//# sourceMappingURL=repo.aa5345e3.js.map
